<template>
  <ResendExpiredLink
    :disabled="hasBeenSent"
    :loading="isLoading"
    :translations
    @click="handleResendLink"
  />
</template>

<script lang="ts" setup>
import ResendExpiredLink from '~/scopes/guest/components/ResendExpiredLink/ResendExpiredLink.vue'
import { useResendGuestLink } from '~/scopes/guest/composables/useResendGuestLink'
import translations from '~/scopes/guest/pages/guest-upgrade-resend-link/GuestUpgradeResendLink.translations'

const { isLoading, hasBeenSent, handleResendLink } = useResendGuestLink(
  'guest_upgrade_access',
  translations,
  'guest_upgrade_resend_link',
)
</script>
